import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_sentryserver_3ef97900 from 'nuxt_plugin_sentryserver_3ef97900' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_4d7ff110 from 'nuxt_plugin_sentryclient_4d7ff110' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_7420976b from 'nuxt_plugin_bootstrapvue_7420976b' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_image_3709b237 from 'nuxt_plugin_image_3709b237' // Source: ./image.js (mode: 'all')
import nuxt_plugin_vuescrollto_76bd9566 from 'nuxt_plugin_vuescrollto_76bd9566' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_veevalidate_4bfb14e2 from 'nuxt_plugin_veevalidate_4bfb14e2' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_0079c505 from 'nuxt_plugin_nuxtuseragent_0079c505' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_templatesplugin7f20d482_fc0b7a56 from 'nuxt_plugin_templatesplugin7f20d482_fc0b7a56' // Source: ./templates.plugin.7f20d482.js (mode: 'client')
import nuxt_plugin_gtm_3330c9dc from 'nuxt_plugin_gtm_3330c9dc' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_libplugin6970d56c_30cc85e6 from 'nuxt_plugin_libplugin6970d56c_30cc85e6' // Source: ./lib.plugin.6970d56c.js (mode: 'all')
import nuxt_plugin_axios_4c02b53c from 'nuxt_plugin_axios_4c02b53c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vlazyload_37c8f52a from 'nuxt_plugin_vlazyload_37c8f52a' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_pluginutils_6315587f from 'nuxt_plugin_pluginutils_6315587f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_adbc7bec from 'nuxt_plugin_pluginrouting_adbc7bec' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_4f0914b6 from 'nuxt_plugin_pluginmain_4f0914b6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7ec25ce4 from 'nuxt_plugin_cookieuniversalnuxt_7ec25ce4' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_jwt_58cb8274 from 'nuxt_plugin_jwt_58cb8274' // Source: ../plugins/jwt.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_formatNumber_773725a1 from 'nuxt_plugin_formatNumber_773725a1' // Source: ../plugins/formatNumber.js (mode: 'all')
import nuxt_plugin_extractQueryParameter_1002e98b from 'nuxt_plugin_extractQueryParameter_1002e98b' // Source: ../plugins/extractQueryParameter.js (mode: 'all')
import nuxt_plugin_isDarkColor_5447708a from 'nuxt_plugin_isDarkColor_5447708a' // Source: ../plugins/isDarkColor.js (mode: 'all')
import nuxt_plugin_utils_1ea7651c from 'nuxt_plugin_utils_1ea7651c' // Source: ../plugins/utils.js (mode: 'all')
import nuxt_plugin_icons_34981d38 from 'nuxt_plugin_icons_34981d38' // Source: ../plugins/icons (mode: 'all')
import nuxt_plugin_vuebar_163abb16 from 'nuxt_plugin_vuebar_163abb16' // Source: ../plugins/vue-bar (mode: 'all')
import nuxt_plugin_vueclipboard_a146e34e from 'nuxt_plugin_vueclipboard_a146e34e' // Source: ../plugins/vue-clipboard (mode: 'all')
import nuxt_plugin_skeleton_6bf43dc3 from 'nuxt_plugin_skeleton_6bf43dc3' // Source: ../plugins/skeleton (mode: 'all')
import nuxt_plugin_vuemq_301d3b7e from 'nuxt_plugin_vuemq_301d3b7e' // Source: ../plugins/vue-mq (mode: 'all')
import nuxt_plugin_veevalidation_42e76ff4 from 'nuxt_plugin_veevalidation_42e76ff4' // Source: ../plugins/vee-validation (mode: 'all')
import nuxt_plugin_clientinit_31582bdb from 'nuxt_plugin_clientinit_31582bdb' // Source: ../plugins/client-init.js (mode: 'client')
import nuxt_plugin_lottie_68e4097c from 'nuxt_plugin_lottie_68e4097c' // Source: ../plugins/lottie.js (mode: 'client')
import nuxt_plugin_dateFilter_1c0943bb from 'nuxt_plugin_dateFilter_1c0943bb' // Source: ../plugins/dateFilter.js (mode: 'client')
import nuxt_plugin_veevalidatordictionary_ae1ba80e from 'nuxt_plugin_veevalidatordictionary_ae1ba80e' // Source: ../plugins/vee-validator-dictionary.js (mode: 'client')
import nuxt_plugin_featureFlag_66d377aa from 'nuxt_plugin_featureFlag_66d377aa' // Source: ../plugins/featureFlag.js (mode: 'all')
import nuxt_plugin_datadog_19a1b94a from 'nuxt_plugin_datadog_19a1b94a' // Source: ../plugins/datadog.js (mode: 'all')
import nuxt_plugin_plugin_a6b83510 from 'nuxt_plugin_plugin_a6b83510' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Airalo","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"msapplication-TileImage","content":"\u002Fmstile-144x144.png"},{"name":"theme-color","content":"#ffffff"},{"property":"og:site_name","content":"Airalo"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fwww.airalo.com\u002Flogo.png"},{"hid":"og:image:width","property":"og:image:width","content":720},{"hid":"og:image:height","property":"og:image:height","content":720},{"property":"og:image:alt","content":"Airalo Logo"},{"property":"fb:app_id","content":"427219981442318"},{"name":"gtm-code","content":"328792766"},{"name":"smartbanner:title","content":"-"},{"name":"smartbanner:author","content":"-"},{"name":"smartbanner:price","content":"-"},{"name":"smartbanner:price-suffix-google","content":"-"},{"name":"smartbanner:price-suffix-apple","content":"-"},{"name":"smartbanner:icon-google","content":"\u002Fapple-icon.png"},{"name":"smartbanner:icon-apple","content":"\u002Fapple-icon.png"},{"name":"smartbanner:button","content":"VIEW"},{"name":"smartbanner:button-url-google","content":"https:\u002F\u002Fgo.airalo.com\u002Fmobile-banner"},{"name":"smartbanner:button-url-apple","content":"https:\u002F\u002Fgo.airalo.com\u002Fmobile-banner"},{"hid":"smartbanner-enabled-platforms","name":"smartbanner:enabled-platforms","content":"android,ios"}],"script":[{"src":"\u002Fassets\u002Fscripts\u002Fsmartbanner.js","body":true},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=328792766","async":true},{"src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-MXF2X3L&gtm_auth=nJ7RMjQeEnDkdl9Xck867w&gtm_preview=env-2')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"stylesheet","rel":"stylesheet","href":"\u002Ffonts\u002Fibm-plex-sans\u002Ffonts.css"},{"rel":"stylesheet","href":"\u002Ffonts\u002Fairalo-icomoon\u002Fairalo-icomoon.css?v1.42.0"},{"rel":"stylesheet","href":"\u002Fassets\u002Fscripts\u002Fsmartbanner.v2.css"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Fandroid-chrome-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"manifest","href":"\u002Fmanifest.json"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg","color":"#df6c5a"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-MXF2X3L&gtm_auth=nJ7RMjQeEnDkdl9Xck867w&gtm_preview=env-2&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.server && typeof nuxt_plugin_sentryserver_3ef97900 === 'function') {
    await nuxt_plugin_sentryserver_3ef97900(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_4d7ff110 === 'function') {
    await nuxt_plugin_sentryclient_4d7ff110(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_7420976b === 'function') {
    await nuxt_plugin_bootstrapvue_7420976b(app.context, inject)
  }

  if (typeof nuxt_plugin_image_3709b237 === 'function') {
    await nuxt_plugin_image_3709b237(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_76bd9566 === 'function') {
    await nuxt_plugin_vuescrollto_76bd9566(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_4bfb14e2 === 'function') {
    await nuxt_plugin_veevalidate_4bfb14e2(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_0079c505 === 'function') {
    await nuxt_plugin_nuxtuseragent_0079c505(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin7f20d482_fc0b7a56 === 'function') {
    await nuxt_plugin_templatesplugin7f20d482_fc0b7a56(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_3330c9dc === 'function') {
    await nuxt_plugin_gtm_3330c9dc(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin6970d56c_30cc85e6 === 'function') {
    await nuxt_plugin_libplugin6970d56c_30cc85e6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_4c02b53c === 'function') {
    await nuxt_plugin_axios_4c02b53c(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_37c8f52a === 'function') {
    await nuxt_plugin_vlazyload_37c8f52a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_6315587f === 'function') {
    await nuxt_plugin_pluginutils_6315587f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_adbc7bec === 'function') {
    await nuxt_plugin_pluginrouting_adbc7bec(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_4f0914b6 === 'function') {
    await nuxt_plugin_pluginmain_4f0914b6(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7ec25ce4 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7ec25ce4(app.context, inject)
  }

  if (typeof nuxt_plugin_jwt_58cb8274 === 'function') {
    await nuxt_plugin_jwt_58cb8274(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_formatNumber_773725a1 === 'function') {
    await nuxt_plugin_formatNumber_773725a1(app.context, inject)
  }

  if (typeof nuxt_plugin_extractQueryParameter_1002e98b === 'function') {
    await nuxt_plugin_extractQueryParameter_1002e98b(app.context, inject)
  }

  if (typeof nuxt_plugin_isDarkColor_5447708a === 'function') {
    await nuxt_plugin_isDarkColor_5447708a(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1ea7651c === 'function') {
    await nuxt_plugin_utils_1ea7651c(app.context, inject)
  }

  if (typeof nuxt_plugin_icons_34981d38 === 'function') {
    await nuxt_plugin_icons_34981d38(app.context, inject)
  }

  if (typeof nuxt_plugin_vuebar_163abb16 === 'function') {
    await nuxt_plugin_vuebar_163abb16(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboard_a146e34e === 'function') {
    await nuxt_plugin_vueclipboard_a146e34e(app.context, inject)
  }

  if (typeof nuxt_plugin_skeleton_6bf43dc3 === 'function') {
    await nuxt_plugin_skeleton_6bf43dc3(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemq_301d3b7e === 'function') {
    await nuxt_plugin_vuemq_301d3b7e(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidation_42e76ff4 === 'function') {
    await nuxt_plugin_veevalidation_42e76ff4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientinit_31582bdb === 'function') {
    await nuxt_plugin_clientinit_31582bdb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lottie_68e4097c === 'function') {
    await nuxt_plugin_lottie_68e4097c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dateFilter_1c0943bb === 'function') {
    await nuxt_plugin_dateFilter_1c0943bb(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidatordictionary_ae1ba80e === 'function') {
    await nuxt_plugin_veevalidatordictionary_ae1ba80e(app.context, inject)
  }

  if (typeof nuxt_plugin_featureFlag_66d377aa === 'function') {
    await nuxt_plugin_featureFlag_66d377aa(app.context, inject)
  }

  if (typeof nuxt_plugin_datadog_19a1b94a === 'function') {
    await nuxt_plugin_datadog_19a1b94a(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_a6b83510 === 'function') {
    await nuxt_plugin_plugin_a6b83510(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
